module.exports = __webpack_public_path__ + "img/main_title.ee17ba1e.png";